$ = jQuery = require('jquery');
require('slick-carousel');
require('mediaelement');


require('./projetos');
require('./contato');

require('slick-carousel/slick/slick.css');
require('animsition/dist/css/animsition.min.css');
require('mediaelement/build/mediaelementplayer.css');
// require('mediaelement/build/mediaelementplayer.css');
// require('mediaelement/build/mediaelementplayer.css');
require('../sass/style.scss');

$(document).ready(() => {


    $(document)
        .on("click", ".show-menu", () => {

            $(this).toggleClass("show-menu");

        })
        .on('click', '.btn-menu', (e) => {

            e.stopPropagation();
            $("body").toggleClass("show-menu");

        })
        .on('click', ".js-goto", (e) => {

            e.preventDefault();
            var target = $(this).attr("href");

            $("body, html").animate({
                scrollTop: $(target).offset().top
            }, 800);
        });

    $("body").animsition({
        inClass: 'fade-in',
        outClass: 'fade-out',
        inDuration: 500,
        outDuration: 800,
        linkElement: '.animsition-link',
        loading: true,
        loadingParentElement: 'body',
        loadingClass: 'animsition-loading',
        loadingInner: '',
        timeout: false,
        timeoutCountdown: 5000,
        onLoadEvent: true,
        browser: ['animation-duration', '-webkit-animation-duration'],
        overlay: false,
        overlayClass: 'animsition-overlay-slide',
        overlayParentElement: 'body',
        transition: (url) => window.location.href = url
    });

    $(".project__category").on("click", ".js-open", function (e) {
        e.preventDefault();
        let $parent = $(this).parents(".project__category"),
            bg:string = $parent.css('background-color');

        $(".projects").css('background-color', bg);
        $parent.toggleClass('active');

        $parent.siblings('.project__category')
            .toggleClass('hidden');
    });

    $(".project__thumbs").slick({
        slidesToShow: 3,
        slidesToScroll: 3,
        dots: true,
        arrows: false,
        speed: 300,
        responsive: [{
            breakpoint: 768,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 2
            }
        },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }]
    });

    $(".site__carousel-text").slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        arrows: false,
        speed: 300,
        autoplay: false,
        asNavFor: '.site__carousel-thumbs',
        responsive: [{
            breakpoint: 1024,
            settings: {
                dots: false
            }
        }]
    });

    $(".site__carousel-thumbs").slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        arrows: false,
        speed: 300,
        autoplay: false,
        asNavFor: '.site__carousel-text',
        responsive: [{
            breakpoint: 1024,
            settings: {
                dots: true
            }
        }]
    });

    $(".app__carousel").slick({
        slidesToScroll: 1,
        slidesToShow: 3,
        centerMode: true,
        centerPadding: '60px',
        variableWidth: true,
        dots: true,
        arrows: false,
        // centerMode: true,
        focusOnSelect: true,
        speed: 300
    });
});


// WEBPACK FOOTER //
// ./src/js/main.ts